import { render, staticRenderFns } from "./marflow.vue?vue&type=template&id=7573238c&lang=pug&"
import script from "./marflow.vue?vue&type=script&lang=js&"
export * from "./marflow.vue?vue&type=script&lang=js&"
import style0 from "./marflow.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports